var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import CatalogObjectAdapter from '@square/dashboard-items-data/adapters/connect/catalog-object';
import { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { A } from '@ember/array';
import { CatalogConnectV2Client, CatalogQuery, CatalogQueryRange, CatalogQueryExact, CatalogQueryText, CatalogQueryBooleanAttribute, CatalogSortedAttributeQuery, CatalogSortedStringIntAttributeQuery } from '@square/dashboard-items-data/clients/catalog-connect-v2';
import { CATEGORY_TYPE } from '@square/dashboard-items-data/models/connect/category/data';
import { ReorderObjectRequest, BatchReorderObjectsRequest } from '@square/dashboard-protos/models/squareup/merchant/api';
import { inject as service } from '@ember/service';
import { CloneCategoryRequest } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/interfaces/clone-category';
import uuid from 'uuid-js';
import { isNone } from '@ember/utils';

// eslint-disable-next-line ember/use-ember-data-rfc-395-imports

import { X_CATALOG_API_SUPPORTED_FEATURES_HEADER_NAME, X_CATALOG_API_SUPPORTED_FEATURES_CHANNEL_INTEGRATIONS } from '@square/dashboard-items-data/utils/api-constants';
import { feature } from '@square/ember-features/macros';
export const ADVANCED_CATEGORIES_API_VERSION = '2023-12-13';
export let SORT_ORDER = /*#__PURE__*/function (SORT_ORDER) {
  SORT_ORDER["ASC"] = "ASC";
  SORT_ORDER["DESC"] = "DESC";
  return SORT_ORDER;
}({});
export let SORT_TYPE = /*#__PURE__*/function (SORT_TYPE) {
  SORT_TYPE["ORDINAL"] = "ORDINAL";
  SORT_TYPE["ALPHABETICAL"] = "ALPHABETICAL";
  return SORT_TYPE;
}({});
export let MOVE_TO = /*#__PURE__*/function (MOVE_TO) {
  MOVE_TO["TOP"] = "TOP";
  MOVE_TO["INSERT"] = "INSERT";
  MOVE_TO["BOTTOM"] = "BOTTOM";
  return MOVE_TO;
}({});
export const CHANNEL_FILTERING_KEY_NONE = 'none';
let Category = (_dec = feature('catalog/use_channel_integrations'), _class = class Category extends CatalogObjectAdapter {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "merchantCatalogDashboardFe", _descriptor, this);
    // @ts-expect-error Type for userRailsPermissions exists in @dashboard namespace, until @square is migrated to
    // @dashboard, we can't type it properly
    _initializerDefineProperty(this, "userRailsPermissions", _descriptor2, this);
    _initializerDefineProperty(this, "isChannelLocationHierarchyEnabled", _descriptor3, this);
  }
  get headers() {
    const supportedFeatures = [];
    if (this.isChannelLocationHierarchyEnabled) {
      supportedFeatures.push(X_CATALOG_API_SUPPORTED_FEATURES_CHANNEL_INTEGRATIONS);
    }
    return {
      'Square-Version': ADVANCED_CATEGORIES_API_VERSION,
      [X_CATALOG_API_SUPPORTED_FEATURES_HEADER_NAME]: supportedFeatures.join(',')
    };
  }
  query(store,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  type, query,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  recordArray) {
    const params = {
      objectTypes: [CatalogObjectType.CATEGORY],
      limit: 100,
      ...query
    };
    if (query.queryOptions) {
      const queryOptions = query.queryOptions;
      if (!query.query) {
        params.query = CatalogQuery.create({});
      }
      const isTopLevelQuery = !isNone(queryOptions.isTopLevel) && queryOptions.isTopLevel !== false;
      const isTopLevelOrdinalSort = queryOptions.sort?.sortBy === SORT_TYPE.ORDINAL && !queryOptions.parentCategoryId;
      if (params.query) {
        // It is better for performance to not include this and let the sort ordinal filter take care of it
        if (isTopLevelQuery && !isTopLevelOrdinalSort) {
          params.query.booleanAttributeQuery = [CatalogQueryBooleanAttribute.create({
            attributeName: 'is_top_level',
            attributeValue: true
          })];
        }
        if (queryOptions.categoryType) {
          params.query.rangeQuery = CatalogQueryRange.create({
            attributeName: 'category_type',
            attributeMinValue: queryOptions.categoryType,
            attributeMaxValue: queryOptions.categoryType
          });
        }
        if (queryOptions.parentCategoryId) {
          params.query.exactQuery = CatalogQueryExact.create({
            attributeName: 'parent_category',
            attributeValue: queryOptions.parentCategoryId
          });
        }
        if (queryOptions.sort) {
          if (queryOptions.sort.sortBy === SORT_TYPE.ALPHABETICAL) {
            params.query.sortedAttributeQuery = CatalogSortedAttributeQuery.create({
              attributeName: 'name',
              sortOrder: queryOptions.sort.order
            });
          } else if (queryOptions.sort.sortBy === SORT_TYPE.ORDINAL) {
            params.query.sortedStringIntAttributeQuery = CatalogSortedStringIntAttributeQuery.create({
              attributeName: 'parent_category',
              attributeValue: queryOptions.parentCategoryId,
              sortOrder: queryOptions.sort.order
            });
          }
        }
        if (queryOptions.text) {
          params.query.textQuery = CatalogQueryText.create({
            keywords: [queryOptions.text]
          });
        }

        // Subcategories cannot differ from parents for channel assignment, so no need to filter when we have a parent
        if (queryOptions.channel && !queryOptions.parentCategoryId) {
          params.query.exactQuery = CatalogQueryExact.create({
            attributeName: 'channels',
            attributeValue: queryOptions.channel
          });
        }
        if (queryOptions.onlineVisibility) {
          params.query.booleanAttributeQuery = params.query.booleanAttributeQuery || [];
          params.query.booleanAttributeQuery.push(CatalogQueryBooleanAttribute.create({
            attributeName: 'online_visibility',
            attributeValue: true
          }));
        }
      }
    }
    return super.query(store, type, params, recordArray);
  }
  isItem(record) {
    return record !== null && typeof record === 'object' && record.type === CatalogObjectType.ITEM;
  }
  getValidChannelIds(item) {
    const rawChannels = item.channels?.toArray() ?? [];
    const validChannelIds = rawChannels.map(channel => typeof channel === 'string' ? channel.trim() : '').filter(channel => channel.length > 0);
    return [...new Set(validChannelIds)];
  }
  itemShouldBackfill(item, channelIds) {
    return !item.channelIntegrations?.length && channelIds.length > 0;
  }
  batchRecords(records, options) {
    // Defensive backfill for menu/category item updates.
    // Some item updates flow through the category adapter, which only sends the legacy
    // `channels` field while CHANNEL_INTEGRATIONS feature header is enabled.
    // To prevent unintended channel disablement, we backfill channel_integrations from channels when missing.
    if (this.isChannelLocationHierarchyEnabled) {
      const itemsToBackfill = records.filter(this.isItem);
      itemsToBackfill.forEach(item => {
        const channelIds = this.getValidChannelIds(item);
        if (this.itemShouldBackfill(item, channelIds)) {
          if (channelIds.length > 0) {
            const channelIntegrations = channelIds.map(channelId => {
              return this.store.createFragment('connect/channel-integrations', {
                channelId,
                state: 'ENABLED'
              });
            });
            item.channelIntegrations = A(channelIntegrations);
          }
        }
      });
    }
    return super.batchRecords(records, options);
  }
  upsertCategory(category, availabilityPeriods = [], itemsById = new Map()) {
    const itemsToRemoveFromCategory = [];
    const itemsToAddToCategory = [];
    for (const [, value] of itemsById) {
      const item = value.item;
      // Item assigned to category
      if (value.isLocallyAssigned) {
        const shouldAssignReportingCategory = category.categoryType !== CATEGORY_TYPE.MENU_CATEGORY && category.categoryType !== CATEGORY_TYPE.KITCHEN_CATEGORY;

        // assign the item to the reporting category if it doesn't already have a reporting category
        if (!item.reportingCategory && shouldAssignReportingCategory) {
          item.reportingCategory = this.store.createFragment('connect/category/membership', {
            categoryId: category.idOrTempId()
          });
        }

        // Check if already assigned in case we retry request
        const isItemAlreadyInCategory = item.categories.toArray().some(cat => cat.categoryId === category.idOrTempId());
        if (!isItemAlreadyInCategory) {
          item.categories.pushObject(this.store.createFragment('connect/category/membership', {
            categoryId: category.idOrTempId()
          }));
        }
        if (!value.isServerAssigned) {
          itemsToAddToCategory.push(item);
        }
      }

      // Item unassigned from category
      if (!value.isLocallyAssigned && value.isServerAssigned) {
        item.categories = A(item.categories.filter(itemCategory => category.id !== itemCategory.categoryId));

        // if item is unassigned from its reporting category, set item.category to null
        if (item.reportingCategory?.categoryId === category.id) {
          item.reportingCategory = null;
        }
        itemsToRemoveFromCategory.push(item);
      }
    }
    category.availabilityPeriods = A(availabilityPeriods);
    const catalogObjects = [category, ...itemsToAddToCategory, ...itemsToRemoveFromCategory, ...availabilityPeriods];
    return this.batchRecords(catalogObjects);
  }

  // NOTE: This does NOT update your Ember Data Model
  // When using this function, you should refresh the moved item after by refetching items or pushing the updated items to the store
  async batchOrderItems(category, itemsById, orderedItemIds) {
    const requests = [];
    for (let i = 0; i < orderedItemIds.length; i++) {
      const itemId = orderedItemIds[i];
      const item = itemsById.get(itemId);
      if (!item) {
        // TS complains since item could be undefined
        // But that should NEVER be the case at this point if an item exists in orderedItemIds it requires an itemById definition
        // Developer error is likely if you encountered this
        throw new Error('No Item By ID defined');
      }
      if (item.isLocallyAssigned && item.hasBeenReordered) {
        const previousItemId = i - 1 >= 0 ? orderedItemIds[i - 1] : undefined;
        if (previousItemId === undefined) {
          requests.push(ReorderObjectRequest.create({
            parentObjectToken: category.id,
            moveTo: ReorderObjectRequest.MoveTo.TOP,
            objectToken: itemId
          }));
          continue;
        }
        requests.push(ReorderObjectRequest.create({
          parentObjectToken: category.id,
          afterObjectToken: previousItemId,
          objectToken: itemId
        }));
      }
    }
    const bottomItems = [];
    for (const [, value] of itemsById) {
      if (!value.moveBottomOrdinal) {
        continue;
      }
      if (value.isLocallyAssigned) {
        bottomItems.push(value);
      }
    }
    const moveBottomItems = bottomItems
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .sort((a, b) => a.moveBottomOrdinal - b.moveBottomOrdinal).map(itemById => itemById.item);
    if (moveBottomItems.length > 0) {
      for (let i = 0; i < moveBottomItems.length; i++) {
        const previousItem = i - 1 >= 0 ? moveBottomItems[i - 1] : null;
        if (!previousItem) {
          requests.push(ReorderObjectRequest.create({
            parentObjectToken: category.id,
            moveTo: ReorderObjectRequest.MoveTo.BOTTOM,
            objectToken: moveBottomItems[i].id
          }));
          continue;
        }
        requests.push(ReorderObjectRequest.create({
          parentObjectToken: category.id,
          afterObjectToken: previousItem?.id,
          objectToken: moveBottomItems[i].id
        }));
      }
    }
    if (requests.length === 0) {
      return;
    }
    const requestsCreated = BatchReorderObjectsRequest.create({
      requests
    });
    await this.merchantCatalogDashboardFe.getClient().batchReorderObjects(requestsCreated);
  }

  // NOTE: This does NOT update your Ember Data Model
  // When using this function, you should refresh the moved category after
  async reorderCategory(categoryToMoveId, precedingCategoryId, parentCategory, moveTo) {
    const requestParams = {
      objectToken: categoryToMoveId
    };
    if (parentCategory) {
      requestParams.parentObjectToken = parentCategory;
    }
    if (precedingCategoryId) {
      requestParams.afterObjectToken = precedingCategoryId;
    }
    if (moveTo && moveTo !== 'INSERT') {
      requestParams.moveTo = moveTo === 'TOP' ? ReorderObjectRequest.MoveTo.TOP : ReorderObjectRequest.MoveTo.BOTTOM;
    }
    if (moveTo === 'INSERT' && !precedingCategoryId) {
      requestParams.moveTo = ReorderObjectRequest.MoveTo.TOP;
    }
    const reorderRequest = ReorderObjectRequest.create(requestParams);
    const requestsCreated = BatchReorderObjectsRequest.create({
      requests: [reorderRequest]
    });
    await this.merchantCatalogDashboardFe.getClient().batchReorderObjects(requestsCreated);
    if (!parentCategory) {
      const category = this.store.peekRecord('connect/category', categoryToMoveId);
      // If we find a category that is removed from parent, set parentCategory to null in store
      // Otherwise ember data thinks it's still in the old parent category
      if (category) {
        category.parentCategory = null;
      }
    }
  }
  async batchDelete(objects) {
    const {
      unmatchedDeletedObjectIds,
      deleted_object_ids
    } = await super.batchDeleteCatalogObjects(objects);

    // Check if other IDs returned as deleted are categories
    unmatchedDeletedObjectIds.forEach(unmatchedId => {
      const category = this.store.peekRecord('connect/category', unmatchedId);
      // If we find a category that is deleted, remove it from the store
      if (category) {
        category.deleteRecord();
        category.unloadRecord();
      }
    });
    return {
      deleted_object_ids
    };
  }
  async duplicateCategory(category, newCategoryName) {
    const response = await CatalogConnectV2Client.cloneCategory(CloneCategoryRequest.create({
      idempotencyKey: uuid.create().toString(),
      categoryId: category.id,
      name: newCategoryName
    }));
    let clonedCategory;

    // Return the first category found in the response, but push all categories to the store
    response.objects.forEach(object => {
      if (object.type === CatalogObjectType.CATEGORY) {
        // Remove deprecated imageId field from the API response before normalization
        // to prevent it from being added to the model and breaking future updates to the category.

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (object.image_id) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          delete object.image_id;
        }
        const normalized = this.store.normalize('connect/category', object);
        const pushedRecord = this.store.push(normalized);
        if (clonedCategory === undefined) {
          clonedCategory = pushedRecord;
        }
      }
    });
    return clonedCategory;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "merchantCatalogDashboardFe", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userRailsPermissions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isChannelLocationHierarchyEnabled", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Category as default };